var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loading-progress',{attrs:{"indeterminate":"","hide-background":"","size":"32","rotate":"","fillDuration":"2","rotationDuration":"1"}})}
var staticRenderFns = []

export { render, staticRenderFns }